import { createTheme } from '@mui/material/styles';
import { darken, lighten } from '@mui/material/';
import { Colors } from 'src/shared/components/styles/colors';
import { svSE } from '@mui/material/locale';
import { svSE as datagridsvSE } from '@mui/x-data-grid';
import { svSE as pickersvSE } from '@mui/x-date-pickers/locales';
import { grey } from '@mui/material/colors';
import shadows from '@mui/material/styles/shadows';

const theme = createTheme(
  {
    typography: {
      fontFamily: '"Source Sans 3"',
    },
    palette: {
      background: {
        default: Colors.PageBackground,
      },
      primary: {
        main: Colors.Blue,
      },
      secondary: {
        main: Colors.Orange.Main,
        light: Colors.Orange.Main,
        dark: Colors.Orange.Dark,
        contrastText: Colors.White,
      },
      error: {
        main: Colors.ChipColors.Red,
        dark: darken(Colors.ChipColors.Red, 0.2),
        light: lighten(Colors.ChipColors.Red, 0.2),
        contrastText: Colors.White,
      },
      warning: {
        main: Colors.ChipColors.Yellow,
        dark: darken(Colors.ChipColors.Yellow, 0.2),
        light: lighten(Colors.ChipColors.Yellow, 0.2),
        contrastText: Colors.White,
      },
      success: {
        main: Colors.ChipColors.Green,
        dark: darken(Colors.ChipColors.Green, 0.2),
        light: lighten(Colors.ChipColors.Green, 0.2),
        contrastText: Colors.White,
      },
      info: {
        main: Colors.ChipColors.Blue,
        dark: darken(Colors.ChipColors.Blue, 0.2),
        light: lighten(Colors.ChipColors.Blue, 0.2),
        contrastText: Colors.White,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          input: {
            '&::placeholder': {
              color: `${grey[500]} !important`,
              fontWeight: `100 !important`,
            },
          },
          a: {
            color: Colors.LinkColor,
          },
          '.section-inset': {
            boxShadow: '0 6px 13px -13px rgba(0,0,0,0.4) inset !important',
          },
          '.Toastify__toast': {
            boxShadow: shadows[10],
          },
          '.mui-toast': {
            padding: '0 8px 0 0',
            '& .Toastify__toast-body': {
              padding: 0,
            },
            '& .Toastify__close-button': {
              color: grey[800],
              marginTop: 8,
              '& > svg': {
                width: 20,
                height: 20,
              },
            },
            '&.member-export': {
              width: 500,
            },
          },
          body: {
            backgroundColor: Colors.PageBackground,
            margin: '0rem !important',
            // scrollbarColor: 'red blue',
            '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
              backgroundColor: 'transparent',
              width: '8px !important',
            },
            '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
              borderRadius: 8,
              backgroundColor: 'rgba(0, 0 ,0 , 0.3)',
              minHeight: 24,
              width: '8px !important',
            },
            '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
              backgroundColor: 'rgba(0, 0 ,0 , 0.5)',
            },
            '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
              backgroundColor: 'rgba(0, 0 ,0 , 0.5)',
            },
            '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
              backgroundColor: 'rgba(0, 0 ,0 , 0.5)',
            },
            '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
              backgroundColor: 'transparent',
            },
            '& .MuiBackdrop-root': {
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
            },
            '& .MuiPaper-outlined': {
              border: '1px solid rgb(196, 196, 196)',
            },
            '.MuiDataGrid-row:nth-of-type(2n+1)': {
              backgroundColor: 'rgba(0,0,0,0.015)',
            },
          },
        },
      },
    },
  },
  pickersvSE,
  datagridsvSE,
  svSE,
);

export default theme;
